import { Component, OnInit, AfterViewInit } from '@angular/core';

import { AuthService, UserService, Register, AppContext } from './../shared';
import { RegisterService } from './register.service';

declare const moment: any;

@Component({
  selector: 'register',
  template: require('./register.component.html'),
  styles: [require('./register.component.scss'), require('../static/static.scss')],
  providers: [RegisterService]
})

export class RegisterComponent implements OnInit, AfterViewInit {
  model: Register = new Register();
  token: string;
  cognitoUser: any;

  premiumPlan: string = 'Premium';
  professionalPlan: string = 'Professional';
  basicPlan: string = 'Basic';
  api500Plan: string = 'API500';
  api1000Plan: string = 'API1000';
  api1500Plan: string = 'API1500';
  api4000Plan: string = 'API4000';
  api15000Plan: string = 'API15000';
  api50000Plan: string = 'API50000';
  api150000Plan: string = 'API150000';
  enterprise6Plan: string = 'Enterprise6';
  enterprise12Plan: string = 'Enterprise12';
  enterprise18Plan: string = 'Enterprise18';

  yearlyPlan: string = 'Yearly';
  monthlyPlan: string = 'Monthly';

  displayVerificationInput: boolean = false;
  verificationCode: string;
  thanksAmount: number = -1;
  thanksDate: string = '';
  frontError: boolean = false;

  firstNameError: string;
  lastNameError: string;

  emailError: string;
  confirmEmailError: string;
  passwordError: string;
  confirmPasswordError: string;

  expMonth: number;
  expYear: number;
  submitted: boolean = false;


  constructor(private authService: AuthService, private userService: UserService, private service: RegisterService, public app: AppContext) {
  }

  ngOnInit() {
    if (this.app.signUpPlan === 'Professional') {
      this.service.accountType = 'Professional';
    } else if (this.app.signUpPlan === 'Premium') {
      this.service.accountType = 'Premium';
    } else if (this.app.signUpPlan === 'Enterprise6') {
      this.service.accountType = 'Enterprise6';
    } else if (this.app.signUpPlan === 'Enterprise12') {
      this.service.accountType = 'Enterprise12';
    } else if (this.app.signUpPlan === 'Enterprise18') {
      this.service.accountType = 'Enterprise18';
    }

    if (this.app.signUpPlanBilling === 'yearly') {
      this.service.billingPeriod = 'Yearly';
    } else {
      this.service.billingPeriod = 'Monthly';
    }

    this.service.updateCost();
  }

  ngAfterViewInit() {
    this.service.updateCost();
  }

  validateFirstName() {
    let firstName = this.model.firstName.trim();
    if (firstName.length > 0) {
      this.firstNameError = '';
    } else {
      this.frontError = true;
      this.firstNameError = 'First Name Required';
    }
  }

  validateLastName() {
    let lastName = this.model.lastName.trim();
    if (lastName.length > 0) {
      this.lastNameError = '';
    } else {
      this.frontError = true;
      this.lastNameError = 'Last Name Required';
    }
  }

  validateEmail() {
    //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    let EMAIL_REGEXP = this.app.EMAIL_REGEXP;

    if (EMAIL_REGEXP.test(this.model.email)) {
      this.emailError = '';
    } else {
      this.frontError = true;
      this.emailError = 'Invalid Email';
    }
  }

  validateConfirmEmail() {
    if (this.model.email !== this.model.confirmEmail) {
      this.frontError = true;
      this.confirmEmailError = 'Email must match';
    } else {
      this.confirmEmailError = '';
    }
  }

  validatePassword() {
    let PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/;

    if (PASSWORD_REGEXP.test(this.model.password) && this.model.password.length >= 8) {
      this.passwordError = '';
    } else if (!PASSWORD_REGEXP.test(this.model.password) && this.model.password.length >= 8) {
      this.frontError = true;
      this.passwordError = 'Invalid Password';
    } else if (PASSWORD_REGEXP.test(this.model.password) && this.model.password.length < 8) {
      this.frontError = true;
      this.passwordError = 'Invalid Password';
    } else {
      this.frontError = true;
      this.passwordError = 'Invalid Password';
    }
  }

  validateConfirmPassword() {
    if (this.model.password !== this.model.confirmPassword) {
      this.frontError = true;
      this.confirmPasswordError = 'Passwords must match';
    } else {
      this.confirmPasswordError = '';
    }
  }

  validateCC() {
    if (this.service.accountType !== 'Basic') {
      if (this.service.card.length !== 13 && this.service.card.length !== 14 && this.service.card.length !== 15 && this.service.card.length !== 16 && this.service.card.length !== 17 && this.service.card.length !== 18 && this.service.card.length !== 19) {
        this.frontError = true;
        this.service.errors.card = 'Card Length Invalid';
      } else {
        this.service.errors.card = '';
      }
    }
  }

  validateExp() {
    let exp = this.service.expiration.split('/');
    this.expMonth = +exp[0];
    this.expYear = +exp[1];

    if (this.service.accountType !== 'Basic') {

      if (this.expMonth <= 0 || this.expMonth >= 13) {
        this.service.errors.expiration = 'Date Invalid';
        this.frontError = true;
      } else if (this.expYear <= 0 || this.expYear >= 100) {
        this.frontError = true;
        this.service.errors.expiration = 'Date Invalid';
      } else {
        this.service.errors.expiration = '';
      }
    }
  }

  validateCVC() {
    if (this.service.accountType !== 'Basic') {
      if (this.service.cvc.length !== 3 && this.service.cvc.length !== 4) {
        this.service.errors.cvc = 'CVC Invalid';
        this.frontError = true;
      } else {
        this.service.errors.cvc = '';
      }
    }
  }

  validateToken() {
    if (this.service.stripeResponse !== null && this.service.stripeStatus !== 200) {
      this.frontError = true;
      this.service.errors.register = 'Credit card verification failed. Please update your card details.';
    }
  }

  clearErrors() {
    this.frontError = false;

    this.firstNameError = '';
    this.lastNameError = '';

    this.emailError = '';

    this.passwordError = '';
    this.confirmPasswordError = '';

    this.service.errors.card = '';
    this.service.errors.expiration = '';
    this.service.errors.cvc = '';
  }

  validatePersonalInformation() {
    this.validateFirstName();
    this.validateLastName();

    this.validateEmail();
    this.validateConfirmEmail();

    this.validatePassword();
    this.validateConfirmPassword();
  }

  register() {
    this.clearErrors();
    this.validatePersonalInformation();

    if (!this.service.freeAccount) {
      this.validateCC();
      this.validateExp();
      this.validateCVC();
      this.validateToken();

      this.service.validateHolderName();
      this.service.validatePostalCode();
    }

    if (!this.frontError) {
      if (this.service.accountType === 'Basic' || this.service.freeAccount) {
        this.service.registerWithCognito(this.model);
      } else {
        this.service.registerProcess(this.model);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/register/register.component.ts